import { createAction, props } from '@ngrx/store';

export const open = createAction('[Sidebar] Open');
export const close = createAction('[Sidebar] Close');
export const toggle = createAction('[Sidebar] Toggle');
export const toggleItem = createAction('[Sidebar] toggleItem', props<{ item: { [key: string]: boolean } }>());
